import { IFrameMessagingBrokerFactory } from "./IFrameCommunication/IFrameMessageBroker";

export const ProductCatalogUIInitializer = {
    initialize: () => {
        initializeIFrame();
    }
}

function initializeIFrame() {
    window.addEventListener("message", handleIFrameMessage, false);
}

function handleIFrameMessage(messageEvent: MessageEvent): void {
    IFrameMessagingBrokerFactory.getIFrameMessagingBroker().processReceivedMessage(messageEvent);
}
